/**
 * Popular times admin endpoints (Admin API). Every write job (recompute, sample data) starts in the background and
 * answers 202 `{ jobId }`; poll `adminJobsApi.getRun(jobId)`. `/admin/*` is rewritten to the Admin API — see api/client.ts.
 */
import { ApiService } from '../apiService'
import type { StartedJobDto } from '../types/adminJobs'
import type {
  PopularityItemOptionDto,
  PopularityItemType,
  PopularityOptionsResponse,
  PopularityRecomputeRequest,
  PopularityStatusDto,
  SyntheticGenerateRequest,
  SyntheticItemDto,
  SyntheticRemoveRequest,
  UpdatePopularityOptionsRequest,
} from '../types/popularity'

export const popularityApi = {
  getOptions: () => ApiService.get<PopularityOptionsResponse>('/admin/popularity/options'),
  /** Partial; 400 `{ message }` names every invalid knob. */
  updateOptions: (request: UpdatePopularityOptionsRequest) =>
    ApiService.put<PopularityOptionsResponse>('/admin/popularity/options', request),
  resetOptions: () => ApiService.post<PopularityOptionsResponse>('/admin/popularity/options/reset'),

  getStatus: () => ApiService.get<PopularityStatusDto>('/admin/popularity/status'),
  recompute: (request: PopularityRecomputeRequest) => ApiService.post<StartedJobDto>('/admin/popularity/recompute', request),

  listSynthetic: () => ApiService.get<SyntheticItemDto[]>('/admin/popularity/synthetic'),
  generateSynthetic: (request: SyntheticGenerateRequest) =>
    ApiService.post<StartedJobDto>('/admin/popularity/synthetic/generate', request),
  removeSynthetic: (request: SyntheticRemoveRequest) =>
    ApiService.post<StartedJobDto>('/admin/popularity/synthetic/remove', request),

  searchItems: (type: PopularityItemType, q: string) =>
    ApiService.get<PopularityItemOptionDto[]>('/admin/popularity/items', { type, q }),
}
